export default {"src":"/_next/static/media/option1Tab.f9a2ad54.svg","height":227,"width":309,"blurWidth":0,"blurHeight":0};